import { render, staticRenderFns } from "./UserBreedList.vue?vue&type=template&id=7deafd04&scoped=true"
import script from "./UserBreedList.vue?vue&type=script&lang=js"
export * from "./UserBreedList.vue?vue&type=script&lang=js"
import style0 from "./UserBreedList.vue?vue&type=style&index=0&id=7deafd04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7deafd04",
  null
  
)

export default component.exports